'use strict';

const paymentURL = '/components/payment.cfc?';

export function addCard() {

    var addCardURL = '/pages/my_account_add_card.cfm';

    popWin({
        title: 'Add Card',
        noAutoWidth: true,
        modal: true,
        width: 600,
        page: addCardURL,
        zIndex: 4000,
        popID: 'popAddBankCard',
    });

}

export function bindAddCard(selector) {
    $(selector).unbind().bind('click', (event) => {
        event.preventDefault();
        addCard();
    });
}

export function initCardForm(stripe) {
    var elements = stripe.elements(),
        cardElement = elements.create('card'),
        cardholderName,
        cardButton,
        cancelButton,
        clientSecret;

    cardElement.mount('#card-element');

    cardholderName = document.getElementById('cardholder-name');
    cardButton = document.getElementById('card-button-save-card');
    cancelButton = document.getElementById('add-card-cancel');
    clientSecret = cardButton.dataset.secret;

    $(cardButton).button();
    $(cancelButton).button();

    cancelButton.addEventListener('click', (event) => {
        event.preventDefault();
        popWinClose('popAddBankCard');
    });

    cardButton.addEventListener('click', (event) => {
        event.preventDefault();

        stripe.handleCardSetup(
            clientSecret,
            cardElement,
            {
                payment_method_data: {
                    billing_details: {
                        name: cardholderName.value,
                    },
                },
            },
        ).then((result) => {
            if (result.error) {
                EQLAPP.STRIPE.showAlert({title: 'Alert', body: result.error.message});
            } else {
                var PaymentMethodID = result.setupIntent.payment_method;
                attachCardToCustomer({
                    paymentMethodID: PaymentMethodID,
                    onSuccess: function (data, _textStatus, _jqXHR) {
                        if ($('#defaultCardCheckbox').is(':checked')) {
                            setDefaultCard(data.DATA.content.id);
                        }
                        updateCards();

                        if ($('#renewCard').length) {
                            refreshCards({
                                dropdownID: 'renewCard',
                            });
                        }
                        if ($('#cardToPay').length) {
                            refreshCards({
                                dropdownID: 'cardToPay',
                            });
                        }

                        refreshDefaultCard();
                        system.refreshUserDetails();
                        redirect_refresh('','/pages/my_account_subscription.cfm','#subscription');

                        popWinClose('popAddBankCard');
                    },
                    onError: function (_data, _textStatus, _jqXHR) {
                        var bodyMessage = 'Unable to assign card to customer at this time.';
                        bodyMessage += 'Please try again later.';
                        EQLAPP.STRIPE.showAlert({
                            title: 'Alert',
                            body: bodyMessage,
                        });
                    },
                });
            }
        });
    });
}

export function getCards(options) {
    if (!options) { options = {}; }
    if (!options.onError) { options.onError = ''; }
    if (!options.onSuccess) { options.onSuccess = ''; }
    if (!options.format) { options.format = ''; }

    var urlMain = paymentURL + jQuery.param({
        method: 'getCards',
        format: 'list',
    });

    $.ajax({
        type: 'GET',
        url: urlMain,
        data: gen_random(),
        cache: false,
        success: function (data, textStatus, jqXHR) {
            options.onSuccess(data, textStatus, jqXHR);
        },
        error: function (data, textStatus, jqXHR) {
            options.onError(data, textStatus, jqXHR);
        },
    });
}

export function getCardCount(options) {
    if (!options) { options = {}; }
    if (!options.onError) { options.onError = ''; }
    if (!options.onSuccess) { options.onSuccess = ''; }
    if (!options.format) { options.format = ''; }

    var urlMain = paymentURL + jQuery.param({
        method: 'getCardCount',
    });

    $.ajax({
        type: 'GET',
        url: urlMain,
        data: gen_random(),
        cache: false,
        success: function (data, textStatus, jqXHR) {
            options.onSuccess(data, textStatus, jqXHR);
        },
        error: function (data, textStatus, jqXHR) {
            options.onError(data, textStatus, jqXHR);
        },
    });
}

export function refreshCards(options) {
    if (!options) { options = {}; }
    if (!options.onError) { options.onError = ''; }
    if (!options.onSuccess) { options.onSuccess = ''; }
    if (!options.dropdownID) {
        console.log('Dropdown ID must be provided. Unable to continue.');
        return;
    }

    getCards({
        format: 'dropdown',
        onSuccess: function (data, textStatus, jqXHR) {
            var i, id, name, element, cardDescription,
                select = document.getElementById(options.dropdownID);
            $(select).find('option').remove();

            for (i = 0; i < data.length; i += 1) {
                cardDescription = data[i].brand + ' ending in ' + data[i].last4;
                id = data[i].id;
                name = cardDescription;
                element = document.createElement('option');
                element.value = id;
                element.textContent = name;
                select.appendChild(element);
            }
            if (isFunction(options.onSuccess)) {
                options.onSuccess(data, textStatus, jqXHR);
            }
        },
        onError: function (_data, _textStatus, _jqXHR) {
            options.onError();
        },
    });
}

export function showAlert(options) {
    if (!options) { options = {}; }
    if (!options.title) { options.title = 'equisoft Live';}
    if (!options.icon) { options.icon = 'info';}
    if (!options.body) { options.body = '';}
    if (!options.onSuccess) { options.onSuccess = '';}

    var htmlcontent = '<div class=\'genericPopup\'>';

    var icon = (options.icon === 'warning') ? 'warning.svg' : 'info.svg';
    htmlcontent += '<img class=\'informationPopupImage\' src=\'/img/' + icon + '\'>';

    htmlcontent += '<div class=\'informationText\'>';
    htmlcontent += '<p>' + options.body + '</p>';
    htmlcontent += '</div>';
    htmlcontent += '</div>';
    htmlcontent += '<a id=\'popOkButton\' class=\'jq_button\'>Ok</a>';

    popWin({
        popID: 'genericCardPop',
        title: options.title,
        classes: 'genericCardPop',
        noAutoWidth: false,
        modal: true,
        zIndex: 5000,
        contents: htmlcontent,
        hideCloseButton: false,
        loadComplete: function () {
            $('.jq_button').button();
            $('#popOkButton').click(() => {
                popWinClose('genericCardPop');
                if (isFunction(options.onSuccess)) {
                    options.onSuccess();
                }
            });
        },
    });

}

export function markOrderPaidPending(orderID) {
    var urlMain = '/components/system.cfc?' + jQuery.param({
        method: 'markOrderPaidPending',
        orderID: orderID,
    });

    $.ajax({
        type: 'POST',
        url: urlMain,
        cache: false,
        error: function (_data, _textStatus, _jqXHR) {
            console.log('MarkOrderPaidPending failed.');
        },
    });
}

function setDefaultCard(cardID) {

    var url = '/components/payment.cfc?' + jQuery.param({
        method: 'setDefaultCard',
        cardID: cardID,
    });

    $.ajax({
        type: 'GET',
        url: url,
        data: gen_random(),
        cache: false,
        dataType: 'JSON',
        success: function (data) {
            if (!data.SUCCESS) {
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    body: 'Error setting card as default. Please try again',
                });
            }
        },
        error: function () {
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Error setting card as default. Please try again',
            });
        },
    });

}

export function disableAutoRenew(options) {
    if (!options) { options = {}; }
    if (!options.onError) { options.onError = ''; }
    if (!options.onSuccess) { options.onSuccess = ''; }

    var urlMain = '/components/system.cfc?' + jQuery.param({
        method: 'disableAutoRenewWeb',
    });

    $.ajax({
        type: 'GET',
        url: urlMain,
        contentType: 'application/json',
        cache: false,
        success: function (data) {
            if (data.success)
            {
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    body: 'Auto Renew Disabled',
                });
                system.refreshUserDetails();
                redirect_refresh('','/pages/my_account_subscription.cfm','#subscription');
            }
        },
        error: function (_data, _textStatus, _jqXHR) {
            console.log('DisableAutoRenew failed.');
        },
    });
}

function attachCardToCustomer(options) {
    if (!options) { options = {}; }
    if (!options.paymentMethodID) { options.paymentMethodID = ''; }
    if (!options.onError) { options.onError = ''; }
    if (!options.onSuccess) { options.onSuccess = ''; }

    var urlMain = paymentURL + jQuery.param({
        method: 'attachPaymentToCustomer',
        paymentID: options.paymentMethodID,
    });

    $.ajax({
        type: 'GET',
        url: urlMain,
        data: gen_random(),
        cache: false,
        dataType: 'JSON',
        success: function (data, textStatus, jqXHR) {
            options.onSuccess(data, textStatus, jqXHR);
        },
        error: function (data, textStatus, jqXHR) {
            options.onError(data, textStatus, jqXHR);
        },
    });
}

function refreshDefaultCard() {
    var url = 'components/payment.cfc?method=getDefaultCard';

    $.ajax({
        type: 'GET',
        url: url,
        data: gen_random(),
        cache: false,
        dataType: 'JSON',
        success: function (data, _textStatus, _jqXHR) {
            if (!data.SUCCESS) {
                EQLAPP.STRIPE.showAlert({
                    title: 'Alert',
                    body: 'Error getting default card. Please refresh the page',
                });
            } else {
                $('#defaultCard').html(data.DATA.TEXT);
            }
        },
        error: function (_data, _textStatus) {
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Error getting default card. Please refresh the page',
            });
        },
    });
}